const options = [
  {
    id: 'official',
    name: 'Official',
  },
  {
    id: 'personal',
    name: 'Private',
  },
];

const getStudentTagTypeFilter = () => ({
  key: 'studentTagType',
  source: 'studentTagType',
  filterName: 'Tag type',
  searchable: false,
  defaultSelection: options,
  options,
  selector: 'id',
  label: 'name',
});

export default getStudentTagTypeFilter;
